import * as angular from 'angular';
import StandardComponent from "components/standards/components/StandardComponent";
import CheckboxFromStationController from "./controllers/checkboxFromStation.controller";

"use strict";

class CheckboxFromStation extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/field/components/checkboxFromStation';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
        scanStation: '<',
        fc: '<',
        field: '<',
        row: '<',
    }


    // This will set what will be the controller of this component
    public controller : any = CheckboxFromStationController;

    // This will set an alias
    public controllerAs: string = 'ch';
}

angular.module('FieldModule').component('checkboxFromStation', <StandardComponent> new CheckboxFromStation);